// Generated types for Step
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ChatRoleType } from '../../shared/enums';

import { ModelRequestWriteAPI } from './modelrequest';
import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ModelRequestWriteAPISchema } from './modelrequest';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface StepReadAPI extends Omit<ScopedNodeReadAPI, 'created_at'> {
  /** When step was created */
  created_at?: string | null;
  /** Thread ID for API operations */
  threadId?: string | null;
  /** Primary content of the step */
  text?: string | null;
  /** Attached files */
  attachments?: string | null;
  /** When step was created */
  created_at_ts?: string | null;
  /** Role of the step */
  role?: ChatRoleType;
  /** Whether this step's processing is complete (all model responses finished) */
  is_complete?: boolean;
  /** Server-stamped: the refusal that ended the turn, as JSON in THE refusal shape {code, reason, failed[], next[]} (schema/types/refusal.py); none for an ordinary step. */
  refusal_json?: string | null;
}

export interface StepWriteAPI extends ScopedNodeWriteAPI {
  /** Thread ID for API operations */
  threadId?: string | null;
  /** Primary content of the step */
  text?: string | null;
  /** Attached files */
  attachments?: string | null;
  model_requests?: (string | ModelRequestWriteAPI)[];
  /** Role of the step */
  role?: ChatRoleType;
  /** Whether this step's processing is complete (all model responses finished) */
  is_complete?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const StepReadAPISchema: z.ZodType<StepReadAPI> = ScopedNodeReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  threadId: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  attachments: z.string().nullable().optional(),
  created_at_ts: z.string().nullable().optional(),
  role: z.nativeEnum(ChatRoleType).optional(),
  is_complete: z.boolean().optional(),
  refusal_json: z.string().nullable().optional(),
}).passthrough();

export const StepWriteAPISchema: z.ZodType<StepWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  threadId: z.string().nullable().optional(),
  text: z.string().nullable().optional(),
  attachments: z.string().nullable().optional(),
  model_requests: z.array(z.union([z.string(), z.lazy(() => ModelRequestWriteAPISchema)])).optional(),
  role: z.nativeEnum(ChatRoleType).optional(),
  is_complete: z.boolean().optional(),
}).passthrough();
